(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("highlight.js/lib/core"), require("highlight.js/lib/languages/bash"), require("highlight.js/lib/languages/cpp"), require("highlight.js/lib/languages/csharp"), require("highlight.js/lib/languages/css"), require("highlight.js/lib/languages/dart"), require("highlight.js/lib/languages/dos"), require("highlight.js/lib/languages/diff"), require("highlight.js/lib/languages/erlang"), require("highlight.js/lib/languages/elixir"), require("highlight.js/lib/languages/plaintext"), require("highlight.js/lib/languages/go"), require("highlight.js/lib/languages/http"), require("highlight.js/lib/languages/java"), require("highlight.js/lib/languages/javascript"), require("highlight.js/lib/languages/typescript"), require("highlight.js/lib/languages/json"), require("highlight.js/lib/languages/objectivec"), require("highlight.js/lib/languages/php"), require("highlight.js/lib/languages/python"), require("highlight.js/lib/languages/ruby"), require("highlight.js/lib/languages/swift"), require("highlight.js/lib/languages/kotlin"), require("highlight.js/lib/languages/sql"), require("highlight.js/lib/languages/xml"), require("highlight.js/lib/languages/yaml"), require("highlightjs-curl/src/languages/curl"));
	else if(typeof define === 'function' && define.amd)
		define([, , , , , , , , , , , , , , , , , , , , , , , , , , , , ], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("prop-types"), require("highlight.js/lib/core"), require("highlight.js/lib/languages/bash"), require("highlight.js/lib/languages/cpp"), require("highlight.js/lib/languages/csharp"), require("highlight.js/lib/languages/css"), require("highlight.js/lib/languages/dart"), require("highlight.js/lib/languages/dos"), require("highlight.js/lib/languages/diff"), require("highlight.js/lib/languages/erlang"), require("highlight.js/lib/languages/elixir"), require("highlight.js/lib/languages/plaintext"), require("highlight.js/lib/languages/go"), require("highlight.js/lib/languages/http"), require("highlight.js/lib/languages/java"), require("highlight.js/lib/languages/javascript"), require("highlight.js/lib/languages/typescript"), require("highlight.js/lib/languages/json"), require("highlight.js/lib/languages/objectivec"), require("highlight.js/lib/languages/php"), require("highlight.js/lib/languages/python"), require("highlight.js/lib/languages/ruby"), require("highlight.js/lib/languages/swift"), require("highlight.js/lib/languages/kotlin"), require("highlight.js/lib/languages/sql"), require("highlight.js/lib/languages/xml"), require("highlight.js/lib/languages/yaml"), require("highlightjs-curl/src/languages/curl")) : factory(root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, (__WEBPACK_EXTERNAL_MODULE__5225__, __WEBPACK_EXTERNAL_MODULE__6073__, __WEBPACK_EXTERNAL_MODULE__9302__, __WEBPACK_EXTERNAL_MODULE__497__, __WEBPACK_EXTERNAL_MODULE__6736__, __WEBPACK_EXTERNAL_MODULE__4260__, __WEBPACK_EXTERNAL_MODULE__7892__, __WEBPACK_EXTERNAL_MODULE__8673__, __WEBPACK_EXTERNAL_MODULE__9857__, __WEBPACK_EXTERNAL_MODULE__3523__, __WEBPACK_EXTERNAL_MODULE__5964__, __WEBPACK_EXTERNAL_MODULE__2870__, __WEBPACK_EXTERNAL_MODULE__7420__, __WEBPACK_EXTERNAL_MODULE__3345__, __WEBPACK_EXTERNAL_MODULE__132__, __WEBPACK_EXTERNAL_MODULE__314__, __WEBPACK_EXTERNAL_MODULE__6257__, __WEBPACK_EXTERNAL_MODULE__9937__, __WEBPACK_EXTERNAL_MODULE__5114__, __WEBPACK_EXTERNAL_MODULE__2519__, __WEBPACK_EXTERNAL_MODULE__1703__, __WEBPACK_EXTERNAL_MODULE__6941__, __WEBPACK_EXTERNAL_MODULE__7684__, __WEBPACK_EXTERNAL_MODULE__5098__, __WEBPACK_EXTERNAL_MODULE__6482__, __WEBPACK_EXTERNAL_MODULE__5501__, __WEBPACK_EXTERNAL_MODULE__6630__, __WEBPACK_EXTERNAL_MODULE__1469__, __WEBPACK_EXTERNAL_MODULE__8488__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 9302:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__9302__;

/***/ }),

/***/ 497:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__497__;

/***/ }),

/***/ 6736:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__6736__;

/***/ }),

/***/ 4260:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__4260__;

/***/ }),

/***/ 7892:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__7892__;

/***/ }),

/***/ 8673:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__8673__;

/***/ }),

/***/ 3523:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__3523__;

/***/ }),

/***/ 9857:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__9857__;

/***/ }),

/***/ 2870:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__2870__;

/***/ }),

/***/ 5964:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__5964__;

/***/ }),

/***/ 3345:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__3345__;

/***/ }),

/***/ 132:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__132__;

/***/ }),

/***/ 314:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__314__;

/***/ }),

/***/ 6257:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__6257__;

/***/ }),

/***/ 5114:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__5114__;

/***/ }),

/***/ 6482:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__6482__;

/***/ }),

/***/ 2519:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__2519__;

/***/ }),

/***/ 1703:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__1703__;

/***/ }),

/***/ 7420:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__7420__;

/***/ }),

/***/ 6941:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__6941__;

/***/ }),

/***/ 7684:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__7684__;

/***/ }),

/***/ 5501:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__5501__;

/***/ }),

/***/ 5098:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__5098__;

/***/ }),

/***/ 9937:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__9937__;

/***/ }),

/***/ 6630:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__6630__;

/***/ }),

/***/ 1469:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__1469__;

/***/ }),

/***/ 8488:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__8488__;

/***/ }),

/***/ 6073:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__6073__;

/***/ }),

/***/ 5225:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__5225__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ component)
});

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react"}
var external_commonjs_react_commonjs2_react_ = __webpack_require__(5225);
var external_commonjs_react_commonjs2_react_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_react_commonjs2_react_);
// EXTERNAL MODULE: external {"commonjs":"prop-types","commonjs2":"prop-types"}
var external_commonjs_prop_types_commonjs2_prop_types_ = __webpack_require__(6073);
var external_commonjs_prop_types_commonjs2_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_prop_types_commonjs2_prop_types_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/core","commonjs2":"highlight.js/lib/core"}
var core_ = __webpack_require__(9302);
var core_default = /*#__PURE__*/__webpack_require__.n(core_);
;// CONCATENATED MODULE: ./src/core/utils/syntax-highlighter.js
 // Map certain frameworks, protocols etc to available langauage packs

var languageToHighlightKey = function languageToHighlightKey(lang) {
  var id;

  if (!lang) {
    lang = "text";
  }

  switch (lang.toLowerCase()) {
    case "android":
      id = "java";
      break;

    case ".net":
    case "net":
    case "dotnet":
    case "csharp":
    case "c#":
      id = "cs";
      break;

    case "objc":
    case "objective c":
      id = "objectivec";
      break;

    case "laravel":
      id = "php";
      break;

    case "flutter":
      id = "dart";
      break;

    case "node.js":
    case "js":
      id = "javascript";
      break;

    case "ts":
      id = "typescript";
      break;

    case "kotlin":
    case "kt":
      id = "kotlin";
      break;

    case "shell":
    case "fh":
    case "sh":
      id = "bash";
      break;

    case "https":
    case "http":
    case "txt":
    case "plaintext":
      id = "text";
      break;

    case "cmd":
    case "bat":
      id = "dos";
      break;

    case "yml":
      id = "yaml";
      break;

    case "erl":
      id = "erlang";
      break;

    case "patch":
      id = "diff";
      break;

    case "svg":
      id = "xml";
      break;

    default:
      break;
  }

  return id || lang;
};

var registerDefaultLanguages = function registerDefaultLanguages(register) {
  register.forEach(function (_ref) {
    var key = _ref.key,
        module = _ref.module;
    return core_default().registerLanguage(key, module);
  });
};

var highlightSnippet = function highlightSnippet(languageKeyword, snippet) {
  var language = languageToHighlightKey(languageKeyword);
  if (typeof snippet !== "string" || !snippet || !language) return;
  return core_default().highlight(snippet, {
    language: language
  }).value;
};


// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/bash","commonjs2":"highlight.js/lib/languages/bash"}
var bash_ = __webpack_require__(497);
var bash_default = /*#__PURE__*/__webpack_require__.n(bash_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/cpp","commonjs2":"highlight.js/lib/languages/cpp"}
var cpp_ = __webpack_require__(6736);
var cpp_default = /*#__PURE__*/__webpack_require__.n(cpp_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/csharp","commonjs2":"highlight.js/lib/languages/csharp"}
var csharp_ = __webpack_require__(4260);
var csharp_default = /*#__PURE__*/__webpack_require__.n(csharp_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/css","commonjs2":"highlight.js/lib/languages/css"}
var css_ = __webpack_require__(7892);
var css_default = /*#__PURE__*/__webpack_require__.n(css_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/dart","commonjs2":"highlight.js/lib/languages/dart"}
var dart_ = __webpack_require__(8673);
var dart_default = /*#__PURE__*/__webpack_require__.n(dart_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/dos","commonjs2":"highlight.js/lib/languages/dos"}
var dos_ = __webpack_require__(9857);
var dos_default = /*#__PURE__*/__webpack_require__.n(dos_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/diff","commonjs2":"highlight.js/lib/languages/diff"}
var diff_ = __webpack_require__(3523);
var diff_default = /*#__PURE__*/__webpack_require__.n(diff_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/erlang","commonjs2":"highlight.js/lib/languages/erlang"}
var erlang_ = __webpack_require__(5964);
var erlang_default = /*#__PURE__*/__webpack_require__.n(erlang_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/elixir","commonjs2":"highlight.js/lib/languages/elixir"}
var elixir_ = __webpack_require__(2870);
var elixir_default = /*#__PURE__*/__webpack_require__.n(elixir_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/plaintext","commonjs2":"highlight.js/lib/languages/plaintext"}
var plaintext_ = __webpack_require__(7420);
var plaintext_default = /*#__PURE__*/__webpack_require__.n(plaintext_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/go","commonjs2":"highlight.js/lib/languages/go"}
var go_ = __webpack_require__(3345);
var go_default = /*#__PURE__*/__webpack_require__.n(go_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/http","commonjs2":"highlight.js/lib/languages/http"}
var http_ = __webpack_require__(132);
var http_default = /*#__PURE__*/__webpack_require__.n(http_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/java","commonjs2":"highlight.js/lib/languages/java"}
var java_ = __webpack_require__(314);
var java_default = /*#__PURE__*/__webpack_require__.n(java_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/javascript","commonjs2":"highlight.js/lib/languages/javascript"}
var javascript_ = __webpack_require__(6257);
var javascript_default = /*#__PURE__*/__webpack_require__.n(javascript_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/typescript","commonjs2":"highlight.js/lib/languages/typescript"}
var typescript_ = __webpack_require__(9937);
var typescript_default = /*#__PURE__*/__webpack_require__.n(typescript_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/json","commonjs2":"highlight.js/lib/languages/json"}
var json_ = __webpack_require__(5114);
var json_default = /*#__PURE__*/__webpack_require__.n(json_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/objectivec","commonjs2":"highlight.js/lib/languages/objectivec"}
var objectivec_ = __webpack_require__(2519);
var objectivec_default = /*#__PURE__*/__webpack_require__.n(objectivec_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/php","commonjs2":"highlight.js/lib/languages/php"}
var php_ = __webpack_require__(1703);
var php_default = /*#__PURE__*/__webpack_require__.n(php_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/python","commonjs2":"highlight.js/lib/languages/python"}
var python_ = __webpack_require__(6941);
var python_default = /*#__PURE__*/__webpack_require__.n(python_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/ruby","commonjs2":"highlight.js/lib/languages/ruby"}
var ruby_ = __webpack_require__(7684);
var ruby_default = /*#__PURE__*/__webpack_require__.n(ruby_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/swift","commonjs2":"highlight.js/lib/languages/swift"}
var swift_ = __webpack_require__(5098);
var swift_default = /*#__PURE__*/__webpack_require__.n(swift_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/kotlin","commonjs2":"highlight.js/lib/languages/kotlin"}
var kotlin_ = __webpack_require__(6482);
var kotlin_default = /*#__PURE__*/__webpack_require__.n(kotlin_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/sql","commonjs2":"highlight.js/lib/languages/sql"}
var sql_ = __webpack_require__(5501);
var sql_default = /*#__PURE__*/__webpack_require__.n(sql_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/xml","commonjs2":"highlight.js/lib/languages/xml"}
var xml_ = __webpack_require__(6630);
var xml_default = /*#__PURE__*/__webpack_require__.n(xml_);
// EXTERNAL MODULE: external {"commonjs":"highlight.js/lib/languages/yaml","commonjs2":"highlight.js/lib/languages/yaml"}
var yaml_ = __webpack_require__(1469);
var yaml_default = /*#__PURE__*/__webpack_require__.n(yaml_);
// EXTERNAL MODULE: external {"commonjs":"highlightjs-curl/src/languages/curl","commonjs2":"highlightjs-curl/src/languages/curl"}
var curl_ = __webpack_require__(8488);
var curl_default = /*#__PURE__*/__webpack_require__.n(curl_);
;// CONCATENATED MODULE: ./src/core/utils/syntax-highlighter-registry.js
// This file can be used in the browser, but because of the weight of all the language
// definitions, preferably it should be used on the server.


























var registry = [{
  label: "Text",
  key: "text",
  module: (plaintext_default())
}, {
  label: "JS",
  key: "javascript",
  module: (javascript_default())
}, {
  label: "TS",
  key: "typescript",
  module: (typescript_default())
}, {
  label: "Java",
  key: "java",
  module: (java_default())
}, {
  label: "Ruby",
  key: "ruby",
  module: (ruby_default())
}, {
  label: "Python",
  key: "python",
  module: (python_default())
}, {
  label: "PHP",
  key: "php",
  module: (php_default())
}, {
  label: "Shell",
  key: "bash",
  module: (bash_default())
}, {
  label: "C#",
  key: "cs",
  module: (csharp_default())
}, {
  label: "CSS",
  key: "css",
  module: (css_default())
}, {
  label: "Go",
  key: "go",
  module: (go_default())
}, {
  label: "HTML",
  key: "xml",
  module: (xml_default())
}, {
  label: "HTTP",
  key: "http",
  module: (http_default())
}, {
  label: "C++",
  key: "cpp",
  module: (cpp_default())
}, {
  label: "Dart",
  key: "dart",
  module: (dart_default())
}, {
  label: "Swift",
  key: "swift",
  module: (swift_default())
}, {
  label: "Kotlin",
  key: "kotlin",
  module: (kotlin_default())
}, {
  label: "Objective C",
  key: "objectivec",
  module: (objectivec_default())
}, {
  label: "Node.js",
  key: "javascript",
  module: (javascript_default())
}, {
  label: "JSON",
  key: "json",
  module: (json_default())
}, {
  label: "DOS",
  key: "dos",
  module: (dos_default())
}, {
  label: "YAML",
  key: "yaml",
  module: (yaml_default())
}, {
  label: "Erlang",
  key: "erlang",
  module: (erlang_default())
}, {
  label: "Elixir",
  key: "elixir",
  module: (elixir_default())
}, {
  label: "Diff",
  key: "diff",
  module: (diff_default())
}, {
  label: "SQL",
  key: "sql",
  module: (sql_default())
}, {
  label: "cURL",
  key: "curl",
  module: (curl_default())
}, {
  label: "HTML",
  key: "html",
  module: (xml_default())
}, {
  label: "XML",
  key: "xml",
  module: (xml_default())
}];
/* harmony default export */ const syntax_highlighter_registry = (registry);
;// CONCATENATED MODULE: ./src/core/Code/component.jsx





registerDefaultLanguages(syntax_highlighter_registry);

var Code = function Code(_ref) {
  var language = _ref.language,
      snippet = _ref.snippet,
      _ref$textSize = _ref.textSize,
      textSize = _ref$textSize === void 0 ? "ui-text-code" : _ref$textSize,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? "p-32" : _ref$padding,
      _ref$additionalCSS = _ref.additionalCSS,
      additionalCSS = _ref$additionalCSS === void 0 ? "" : _ref$additionalCSS;
  var HTMLraw = highlightSnippet(language, "".concat(snippet).trim());
  var className = "language-".concat(language, " ").concat(textSize);
  return /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "hljs overflow-auto ".concat(padding, " ").concat(additionalCSS),
    "data-id": "code"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("pre", {
    lang: language
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("code", {
    className: className,
    dangerouslySetInnerHTML: {
      __html: HTMLraw
    }
  })));
};

Code.propTypes = {
  language: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
  snippet: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
  textSize: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
  padding: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
  additionalCSS: (external_commonjs_prop_types_commonjs2_prop_types_default()).string
};
/* harmony default export */ const component = (Code);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});